import '../../../tc-vue-mixins/src/form-mixins.scss.js';
import '../../../tc-vue-mixins/src/edit-mode.js';
import formField from '../../../tc-vue-mixins/src/form-field.js';
import '../../../tc-vue-mixins/src/input-values.js';
import validatable from '../../../tc-vue-mixins/src/validatable.js';
import '../../../tc-vue-mixins/src/overlays.js';
import TcLabel from '../../tc-label/src/TcLabel.vue.js';
import TcValidationError from '../../tc-form-states/src/TcValidationError.vue.js';
import TcValidationPending from '../../tc-form-states/src/TcValidationPending.vue.js';

//

var types = ['text', 'tel', 'email'];

var script = {
  name: 'TcTextInput',
  components: {
    TcLabel: TcLabel,
    TcValidationPending: TcValidationPending,
    TcValidationError: TcValidationError
  },
  mixins: [formField, validatable],
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'text',
      validator: function (type) { return types.includes(type); }
    }
  },
  computed: {
    // https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
    eventListeners: function eventListeners() {
      var vm = this;
      return Object.assign({}, vm.$listeners,
        // This is needed for v-model to work, see link above
        {input: function input(event) {
          var value = event.target.value;
          vm.$emit('input', value);
        }})
    },
    classes: function classes() {
      var classList = ['tc-text-input-container'];
      if (this.hasLabel) {
        classList.push('tc-validation-icon--has-label');
      }
      if (this.valid) {
        classList.push("tc-text-input--valid");
      } else if (this.invalid) {
        classList.push('tc-text-input--invalid');
      } else if (this.pending) {
        classList.push('tc-text-input--pending');
      }
      return classList
    }
  }
};

export default script;
